import React, { useState } from "react";
import TailwindFlex from "library/components/_tailwind/flex";
import TailwindButton from "library/components/_tailwind/button";
import config from "core/config";
import {
  isProductionMode,
  setProductionMode,
  PRODUCTION_OVERRIDES,
} from "core/config/production-overrides";

type Props = {};

const QAWidgetProduction: React.ComponentType<Props> = () => {
  const [enabled, setEnabled] = useState<boolean>(isProductionMode());

  const handleToggle = () => {
    const newValue = !enabled;
    setProductionMode(newValue);
    setEnabled(newValue);
    window.location.reload();
  };

  return (
    <TailwindFlex flexDirection='flex-col' gap='gap-4' padding={["p-4"]}>
      <TailwindFlex flexDirection='flex-col' gap='gap-2'>
        <div className='text-lg font-bold'>Production Mode</div>
        <div className='text-sm text-gray-600'>
          Overrides QA config values with production values. Page reloads on toggle.
        </div>
      </TailwindFlex>

      <TailwindFlex
        flexDirection='flex-col'
        gap='gap-3'
        padding={["p-3"]}
        className={[
          enabled ? "bg-green-100" : "bg-gray-100",
          "rounded",
        ]}>
        <div className='font-semibold'>
          Status: {enabled ? "Production" : "QA (Default)"}
        </div>
        <TailwindFlex
          flexDirection='flex-col'
          gap='gap-1'
          className={["text-sm", "font-mono"]}>
          {Object.entries(PRODUCTION_OVERRIDES).map(([key]) => (
            <div key={key}>
              <span className='text-gray-600'>{key}:</span>{" "}
              {(config as any)[key] || "—"}
            </div>
          ))}
        </TailwindFlex>
      </TailwindFlex>

      <TailwindFlex gap='gap-3'>
        <TailwindButton
          backgroundColor={enabled ? "secondary" : "primary"}
          onClick={handleToggle}>
          {enabled ? "Disable Production Mode" : "Enable Production Mode"}
        </TailwindButton>
      </TailwindFlex>
    </TailwindFlex>
  );
};

export default QAWidgetProduction;
